import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import { baseUrl, userLocation, ipAddress, userName } from '../Univ.js';

function EditEqp() {
  const { id } = useParams();
  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [manus, setManus] = useState([]);
  const [dists, setDists] = useState([]);
  const [subcats, setSubcats] = useState([]);
  const [labsubcats, setLabsubCats] = useState([]);
  const [registerFormData, setRegisterFormData] = useState({
    dist: '',
    hsn: '',
    product: '',
    pack: '',
    totqty: '',
    batch: '',
    expiry: '',
    subcat: '',
    mrp: '',
    pprice: '',
    sgst: '',
    cgst: '',
    uamount: '',
    status: '',
    addedby: '',
    ip_add: '',
  });

  useEffect(() => {
    axios.get(`${baseUrl}update-eqp-qty/${id}/`)
      .then(response => {
        const data = response.data;
        setRegisterFormData({
          supp: data.supp.id,
          product: data.product,
          batch: data.batch,
          expiry: data.expiry,
          sgst: data.sgst,
          uamount: data.uamount,
          pack: data.pack,
          totqty: data.totqty,
          hsn: data.hsn,
          mrp: data.mrp,
          pprice: data.pprice,
          subcat: data.subcat.id,
          ppat: parseInt(data.ppat) || 0,
          pqty: parseInt(data.pqty) || 0,
          labsubcat: data.labsubcat ? data.labsubcat.id : '',
          cat: data.subcat.cat.category,
        });
      })
      .catch(error => console.log(error));
  }, [id]);

  useEffect(() => {
    axios.get(`${baseUrl}add-supplier/`)
      .then(response => setDists(response.data))
      .catch(error => console.log(error));

    axios.get(`${baseUrl}eqp-subcat/`)
      .then(response => setSubcats(response.data))
      .catch(error => console.log(error));

    axios.get(`${baseUrl}subcat/`)
      .then(response => setLabsubCats(response.data))
      .catch(error => console.log(error));
  }, []);

  const handleChange = (event) => {
    setRegisterFormData({
      ...registerFormData,
      [event.target.name]: event.target.value,
    });
  };

  const calculateDeduction = () => {
    const { pack, mrp } = registerFormData;
    const uamount = (parseFloat(mrp) / parseFloat(pack)).toFixed(2);
    setRegisterFormData(prevState => ({
      ...prevState,
      uamount,
    }));
  };

  useEffect(() => {
    if (registerFormData.pack !== '') {
      calculateDeduction();
    }
  }, [registerFormData.pack, registerFormData.mrp]);

  const submitHandler = (e) => {
    e.preventDefault();
    const supp = document.getElementById("supp").value;
    const formData = new FormData();
    formData.append('product', registerFormData.product);
    formData.append('batch', registerFormData.batch);
    formData.append('expiry', registerFormData.expiry);
    formData.append('sgst', registerFormData.sgst);
    formData.append('cgst', registerFormData.sgst);
    formData.append('hsn', registerFormData.hsn);
    formData.append('subcat', registerFormData.subcat);
    formData.append('pack', registerFormData.pack);
    formData.append('totqty', registerFormData.totqty);
    formData.append('mrp', registerFormData.mrp);
    formData.append('pprice', registerFormData.pprice);
    formData.append('uamount', registerFormData.uamount);
    formData.append('ppat', parseInt(registerFormData.ppat));
    formData.append('pqty', parseInt(registerFormData.pqty));
    formData.append('labsubcat', registerFormData.labsubcat ? parseInt(registerFormData.labsubcat) : null);
    formData.append('supp', supp);
    formData.append('status', '1');
    formData.append('addedby', userName);
    formData.append('ip_add', ipAddress);
    formData.append('location', userLocation);

    axios.put(`${baseUrl}update-eqp-qty/${id}/`, formData)
      .then(response => {
        if (response.status === 200 || response.status === 201) {
          Swal.fire({
            title: 'Equipment has been updated.',
            icon: 'success',
            timer: 5000,
            showConfirmButton: false,
          });
          setTimeout(() => {
            window.location.href = '/equip-list/';
          }, 3000);
        }
      })
      .catch(error => {
        console.log(error);
        Swal.fire(
          'Error!',
          'Failed to update. Please try again later.',
          'error'
        );
      });
  };

  return (
    <section className="container mt-4">
      <div className="row">
        <div className="col-md-8 col-12">
          <div className="card">
            <h4 className="card-header text-center">Edit Equipment</h4>
            <div className="card-body">
              <p className="text-muted"><strong>Note:</strong> All fields are mandatory</p>
              {successMsg && <p className="text-success">{successMsg}</p>}
              {errorMsg && <p className="text-danger">{errorMsg}</p>}
              <form onSubmit={submitHandler}>
                <div className="row">
                  <div className="col-md-4 mb-3">
                    <label htmlFor="supp" className="form-label">Supplier</label>
                    <select name="supp" id="supp" value={registerFormData.supp} onChange={handleChange} className="form-control">
                      {dists.map((distr, index) => (
                        <option key={index} value={distr.id}>{distr.name}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-5 mb-3">
                    <label htmlFor="product" className="form-label">Equipment Name</label>
                    <input type="text" placeholder="Equipment Name" className="form-control" name="product" value={registerFormData.product} onChange={handleChange} />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-3 mb-3">
                    <label htmlFor="hsn" className="form-label">HSN</label>
                    <input type="text" placeholder="HSN" className="form-control" name="hsn" value={registerFormData.hsn} onChange={handleChange} />
                  </div>
                  <div className="col-md-3 mb-3">
                    <label htmlFor="batch" className="form-label">Batch</label>
                    <input type="text" placeholder="Batch" className="form-control" name="batch" value={registerFormData.batch} onChange={handleChange} />
                  </div>
                  <div className="col-md-3 mb-3">
                    <label htmlFor="expiry" className="form-label">Expiry</label>
                    <input type="text" placeholder="Expiry" className="form-control" name="expiry" value={registerFormData.expiry} onChange={handleChange} />
                  </div>
                  <div className="col-md-3 mb-3">
                    <label htmlFor="subcat" className="form-label">Sub Category</label>
                    <select name="subcat" id="subcat" value={registerFormData.subcat} onChange={handleChange} className="form-control">
                      {subcats.map((subcat, index) => (
                        <option key={index} value={subcat.id}>{subcat.subcat}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="row">
                  {registerFormData.cat === "Lab" && (
                    <>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="labsubcat" className="form-label">Lab Test</label>
                        <select name="labsubcat" value={registerFormData.labsubcat} onChange={handleChange} className="form-control">
                          {labsubcats.map((subcategory, index) => (
                            <option key={index} value={subcategory.id}>{subcategory.subcat}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-2 mb-3">
                        <label htmlFor="ppat" className="form-label">Per Patient</label>
                        <input type="number" placeholder="Per Patient" className="form-control" min={1} name="ppat" value={registerFormData.ppat} onChange={handleChange} />
                      </div>
                      <div className="col-md-2 mb-3">
                        <label htmlFor="pqty" className="form-label">Per Qty</label>
                        <input type="number" placeholder="Per Qty" className="form-control" min={1} name="pqty" value={registerFormData.pqty} onChange={handleChange} />
                      </div>
                    </>
                  )}
                </div>
                <div className="row">
                  <div className="col-md-2 mb-3">
                    <label htmlFor="pack" className="form-label">Pack</label>
                    <input type="number" placeholder="Pack" className="form-control" name="pack" value={registerFormData.pack} onChange={handleChange} />
                  </div>
                  <div className="col-md-2 mb-3">
                    <label htmlFor="totqty" className="form-label">TQty</label>
                    <input type="number" placeholder="TQty" className="form-control" name="totqty" value={registerFormData.totqty} onChange={handleChange} />
                  </div>
                  <div className="col-md-2 mb-3">
                    <label htmlFor="mrp" className="form-label">MRP</label>
                    <input type="number" placeholder="MRP" className="form-control" name="mrp" value={registerFormData.mrp} onChange={handleChange} />
                  </div>
                  <div className="col-md-2 mb-3">
                    <label htmlFor="pprice" className="form-label">Pur.Price</label>
                    <input type="number" placeholder="Pur.Price" className="form-control" name="pprice" value={registerFormData.pprice} onChange={handleChange} />
                  </div>
                  <div className="col-md-2 mb-3">
                    <label htmlFor="sgst" className="form-label">SGST</label>
                    <input type="number" placeholder="SGST" className="form-control" name="sgst" value={registerFormData.sgst} onChange={handleChange} />
                  </div>
                  <div className="col-md-2 mb-3">
                    <label htmlFor="uamount" className="form-label">Unit Amount</label>
                    <input type="number" placeholder="U Amount" className="form-control" name="uamount" value={registerFormData.uamount} onChange={handleChange} />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 text-center">
                    <button type="submit" className="btn btn-success">Update</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default EditEqp;
